import { NgClass , NgIf} from '@angular/common';
import { AfterViewInit, Component, DestroyRef, inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';


import { NgxToastrService } from '../_services/ngx-toastr/ngx-toastr.service';
import { HttpServiceService } from '../services/http-service.service';
import { LocalStorageService } from '../services/local-storage.service';
import { LoadingService } from '../services/loading.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';



@Component({
  selector: 'app-login',
  standalone: true,
  imports: [NgClass, NgIf, ReactiveFormsModule, RouterModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnDestroy {
  hide_show: boolean = false;
  loginForm: FormGroup;
  private httpService = inject(HttpServiceService);
  private localStorageService = inject(LocalStorageService);
  loadingService = inject(LoadingService);  
  metadataSubsription! : Subscription;
  loginSubscription! : Subscription;
  logo : string  = '';
  private distroyRef = inject(DestroyRef);

  constructor(private fb: FormBuilder, private router : Router, private alertService: NgxToastrService){
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  ngOnInit(){
    // Partner-specific logo when the tenant provides one, otherwise the
    // bundled ServeFar logo so the login page is never blank.
    this.logo = this.httpService.getLogoUrl() || "assets/images/servefar-logo.svg";
  }

  passwordHide(){
    this.hide_show = !this.hide_show;
  }

  onSubmit(): void {
    if (this.loginForm.valid) {      
      this.loginSubscription = this.httpService.loginUser(this.loginForm.value).subscribe({
        next: (response) => {
          if(response['data']?.password_reset_required){
            this.router.navigate(['/', 'reset-password', response['data']?.password_reset_token]);
          }else{
            this.getPermissions(response["data"]);            
          }
        },
        error: (error) => {          
          console.log(error.error);
        }
      });
    } else {
      console.log('Form is invalid.');      
    }
  }

  getPermissions(userInfo : any){
    this.httpService.getUserPermissions().pipe(takeUntilDestroyed(this.distroyRef)).subscribe({
      next : (response) => {
        let userPermissionsList = response.data?.["permissions"] ?? [];
        this.localStorageService.setUserPermissions(userPermissionsList);
        this.localStorageService.setItem("userInfo", userInfo);
        this.router.navigate(['/', 'admin']);
      }
    })
  }

  ngOnDestroy() : void {
    this.loginSubscription?.unsubscribe();    
  }

}
